














import { defineComponent } from "@vue/composition-api";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { TEXT } from "@/lib/const";
import providers from "@/lib/providers";
import { BaseViewRows, FormField, FormValues } from "@/types";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BlockBaseViewText from "@/components/BlockBaseViewText.vue";
import { fields } from "./config";

export default defineComponent({
  name: "BlockUserNotes",
  components: { BlockBaseViewText, BlockBase, BlockBaseForm },
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data() {
    return {
      title: "Notes",
      editing: false,
      notes: null as string | null,
    };
  },
  computed: {
    fields(): FormField[] {
      return fields.map(item => {
        if (item.name === "notes") {
          item.value = this.notes;
        }
        return item;
      });
    },
    rows(): BaseViewRows {
      return [{ fields: [this.notes || TEXT.FIELD_EMPTY], separator: " " }];
    },
    userId(): string {
      return this.user.id;
    },
  },
  methods: {
    async save(data: FormValues) {
      const response = await providers.UserNotesProvider.update({
        data: {
          notes: data.notes,
          userId: this.userId,
        },
      });
      this.notes = response.notes;
      this.editing = false;
    },
    async getData() {
      const response = await providers.UserNotesProvider.find({ id: this.userId });
      this.notes = response.notes;
    },
  },
  created() {
    this.getData();
  },
});
